import { Card, Col, Row } from "antd";
import LineChart from "components/charts/LineChart";
import Scorecard from "components/charts/Scorecard";
import ChartTitle from "components/ChartTitle";
import CategoryScorecard from "../CategoryScorecard";
import { GRID_GUTTER } from "constants/ui";
import { useFormatNumber } from "hooks/useFormatNumber";
import { DIMENSION_DATE } from "constants/dimensions";
import { useMemo } from "react";
import { isEmpty, sum } from "lodash";
import { gray800 } from "constants/colors";

const ReportSection = ({
  data,
  totalDataKey,
  title,
  chartLines,
  variantIds,
  variantDataKeyFormatter = (id) => id, // default: use variant ID as-is
  categoryScorecards, // optional: [{ dataKey, title }]
}) => {
  const formatNumber = useFormatNumber();

  const total = useMemo(() => {
    if (isEmpty(data)) return 0;
    return sum(data.map((item) => Number(item[totalDataKey]) || 0));
  }, [data, totalDataKey]);

  return (
    <>
      <Col span={24}>
        <ChartTitle>{title}</ChartTitle>
      </Col>
      {/* graph */}
      <Col xs={24} lg={12} className="mb-8">
        <Card size="small">
          <LineChart
            xAxisDataKey={DIMENSION_DATE}
            data={data}
            lines={chartLines}
          />
        </Card>
      </Col>
      {/* scorecards */}
      <Col xs={24} lg={12} className="mb-8">
        <Row gutter={GRID_GUTTER}>
          <Col span={24} className="mb-8">
            <Card size="small">
              <Scorecard
                title={title}
                value={formatNumber(total)}
                chartProps={{
                  data,
                  lines: [
                    {
                      name: `Total ${title}`,
                      fill: gray800,
                      dataKey: totalDataKey,
                    },
                  ],
                }}
              />
            </Card>
          </Col>
          {variantIds &&
            variantIds.length > 0 &&
            // render variant scorecards
            variantIds.map((variantId, index) => (
              <CategoryScorecard
                key={variantId}
                data={data}
                dataKey={variantDataKeyFormatter(variantId)}
                title={`variant ${variantId}`}
                total={total}
                colorIndex={index}
              />
            ))}
          {categoryScorecards?.length > 0 &&
            categoryScorecards.map(({ dataKey, title: cardTitle }, index) => (
              <CategoryScorecard
                key={dataKey}
                data={data}
                dataKey={dataKey}
                title={cardTitle}
                total={total}
                colorIndex={(variantIds?.length || 0) + index}
              />
            ))}
        </Row>
      </Col>
    </>
  );
};

export default ReportSection;
